<template>
  <Guide :titleList="titleList" :isHasChild="true">
    <template #innerContent>
      <div style="width: 100%;height: 50px;margin-top: 30px">
      </div>
      <h1>{{ $t('new.guide.message.title') }}</h1>
      <div>
        {{ $t('new.text.1') }}
      </div>
      <br>
      <br>
      <div>
        {{ $t('new.text.2') }}
      </div>
      <br>
      <br>
      <div>
        {{ $t('new.text.3') }}
      </div>
      <br>
      <br>
      <ImageShow :url="image1"/>
      <br>
      <br>
      <div><span style="font-weight: 500">{{ $t('new.text.w.1') }}</span>{{ $t('new.text.n.1') }}</div>
      <br>
      <br>
      <ImageShow :url="image2"/>
      <br>
      <br>
      <div><span style="font-weight: 500">{{ $t('new.text.w.1') }}</span>{{ $t('new.text.n.2') }}</div>
      <br>
      <ImageShow :url="image3"/>
      <br>
      <ImageShow :url="image4"/>
      <br>
      <br>
      <div>{{ $t("new.show.txt") }}</div>
      <br>
      <br>
      <div id="part1" style="margin-top: 30px;">
        <CollapseItem :title="$t('new.guide.part.1.title')" :level="1" v-model:visible="isShow1">
          <br>
          <ImageShow :url="image5"/>
          <br>
          <div>{{ $t('new.wy.t.1') }}</div>
          <br>
          <ImageShow :url="image6"/>
          <br>
          <div>
            {{ $t('new.wy.t.2-1') }}
            <span style="font-weight: 500;">{{ $t('new.wy.t.2-2') }}</span>
            {{ $t('new.wy.t.2-3') }}
            <span style="font-weight: 500;">{{ $t('new.wy.t.2-4') }}</span>
            {{ $t('new.wy.t.2-5') }}
            <span style="font-weight: 500;">{{ $t('new.wy.t.2-6') }}</span>
          </div>
          <br>
          <ImageShow :url="image7"/>
          <br>
          <div>
            <div>{{ $t('new.wy.t.3') }}</div>
            <ul>
              <li>{{ $t('new.wy.t.4') }}</li>
              <li>{{ $t('new.wy.t.5') }}</li>
              <li>{{ $t('new.wy.t.6') }}</li>
              <li>{{ $t('new.wy.t.7-1') }}<span
                  style="font-weight: 500;color: red">{{ $t('new.wy.t.7-2') }}</span>{{ $t('new.wy.t.7-3') }}
              </li>
            </ul>
          </div>
          <br>
          <ImageShow :url="image8"/>
          <br>
          <div>{{ $t('new.wy.t.8') }}</div>
          <br>
          <ImageShow :url="image9"/>
          <br>
          <div>{{ $t('new.wy.t.9') }}</div>
          <br>
        </CollapseItem>
      </div>
      <div id="part2" style="margin-top: 30px;">
        <CollapseItem :title="$t('new.guide.part.2.title')" :level="1" v-model:visible="isShow2">
          <ImageShow :url="image10"/>
          <br>
          <div>{{ $t('new.qq.t.1') }}</div>
          <br>
          <ImageShow :url="image11"/>
          <br>
          <div>{{ $t('new.qq.t.2') }}</div>
          <br>
          <ImageShow :url="image12"/>
          <br>
          <div>
            <div>{{ $t('new.wy.t.3') }}</div>
            <ul>
              <li>{{ $t('new.qq.t.3') }}</li>
              <li>{{ $t('new.qq.t.4') }}</li>
              <li>{{ $t('new.qq.t.5-1') }}<span
                  style="font-weight: 500;color: red">{{ $t('new.qq.t.5-2') }}</span>{{ $t('new.qq.t.5-3') }}
              </li>
            </ul>
          </div>
          <br>
          <ImageShow :url="image13"/>
          <br>
          <div>{{ $t('new.qq.t.6') }}</div>
          <br>
          <ImageShow :url="image14"/>
          <br>
          <div>
            {{ $t('new.qq.t.7') }}
          </div>
          <br>
        </CollapseItem>
      </div>
      <div id="part3" style="margin-top: 30px;">
        <CollapseItem :title="$t('new.guide.part.3.title')" :level="1" v-model:visible="isShow3">
          <br>
          <ImageShow :url="image15"/>
          <br>
          <ImageShow :url="image16"/>
          <br>
          <div>
            {{ $t('new.al.t.1') }}
            <span style="font-weight: 500">{{ $t('new.al.t.1-2') }}</span>
            {{ $t('new.al.t.1-3') }}
            <span style="font-weight: 500">{{ $t('new.al.t.1-4') }}</span>
            {{ $t('new.al.t.1-5') }}
          </div>
          <br>
          <ImageShow :url="image17"/>
          <br>
          <div>{{ $t('new.al.t.2') }}</div>
          <br>
          <ImageShow :url="image18"/>
          <br>
          <div>
            {{ $t('new.al.t.3-1') }}
            <span style="font-weight: 500;">{{ $t('new.al.t.3-2') }}</span>
            {{ $t('new.al.t.3-3') }}
          </div>
          <br>
          <div>
            {{ $t('new.al.t.4-1') }}
            <span style="font-weight: 500;color: red">{{ $t('new.al.t.4-2') }}</span>
            {{ $t('new.al.t.4-3') }}
          </div>
          <br>
        </CollapseItem>
      </div>
      <div id="part4" style="margin-top: 30px;">
        <CollapseItem :title="$t('new.guide.part.4.title')" :level="1" v-model:visible="isShow4">
          <br>
          <ImageShow :url="image19"/>
          <br>
          <div>{{ $t('new.gl.t.1') }}</div>
          <br>
          <ImageShow :url="image20"/>
          <br>
          <div>
            {{ $t('new.gl.t.2-1') }}
            <span style="font-weight: 500;">{{ $t('new.gl.t.2-2') }}</span>
            {{ $t('new.gl.t.2-3') }}
          </div>
          <br>
          <div>{{ $t('new.gl.t.3') }}</div>
          <br>
          <ImageShow :url="image21"/>
          <br>
          <div>{{ $t('new.gl.t.4') }}</div>
          <br>
          <ImageShow :url="image22"/>
          <br>
          <div>{{ $t('new.gl.t.5') }}</div>
          <br>
          <br>
        </CollapseItem>
      </div>
      <div id="part5" style="margin-top: 30px;">
        <CollapseItem :title="$t('new.guide.part.5.title')" :level="1" v-model:visible="isShow5">
          <br><br>
          <div>{{ $t('new.end.txt') }}</div>
          <br><br><br><br><br><br>
        </CollapseItem>
      </div>
    </template>

  </Guide>
</template>

<script setup>

import Guide from "@/views/FileDoc/components/Guide.vue";
import {ref} from "vue";
import {useRouter} from "vue-router";
import CollapseItem from "@/views/FileDoc/components/CollapseItem.vue";
import {i18n} from "@/lang";
import ImageShow from "@/views/FileDoc/components/ImageShow.vue";
import image1 from "@/assets/settingGuideImg/image (1).png"
import image2 from "@/assets/settingGuideImg/image (2).png"
import image3 from "@/assets/settingGuideImg/image (3).png"
import image4 from "@/assets/settingGuideImg/image (4).png"
import image5 from "@/assets/settingGuideImg/image (5).png"
import image6 from "@/assets/settingGuideImg/image (6).png"
import image7 from "@/assets/settingGuideImg/image (7).png"
import image8 from "@/assets/settingGuideImg/image (8).png"
import image9 from "@/assets/settingGuideImg/image (9).png"
import image10 from "@/assets/settingGuideImg/image (10).png"
import image11 from "@/assets/settingGuideImg/image (11).png"
import image12 from "@/assets/settingGuideImg/image (12).png"
import image13 from "@/assets/settingGuideImg/image (13).png"
import image14 from "@/assets/settingGuideImg/image (14).png"
import image15 from "@/assets/settingGuideImg/image (15).png"
import image16 from "@/assets/settingGuideImg/image (16).png"
import image17 from "@/assets/settingGuideImg/image (17).png"
import image18 from "@/assets/settingGuideImg/image (18).png"
import image19 from "@/assets/settingGuideImg/image (19).png"
import image20 from "@/assets/settingGuideImg/image (20).png"
import image21 from "@/assets/settingGuideImg/image (21).png"
import image22 from "@/assets/settingGuideImg/image (22).png"

const router = useRouter()

const flags = true
const isShow1 = ref(flags);
const isShow2 = ref(flags);
const isShow3 = ref(flags);
const isShow4 = ref(flags);
const isShow5 = ref(flags)
const titleList = [{
  id: 1,
  title: i18n.global.t('new.guide.part.1.title'),
  href: "#part1",
  isExpanded: false,
  childList: [],
}, {
  id: 2,
  title: i18n.global.t('new.guide.part.2.title'),
  href: "#part2",
  isExpanded: false,
  childList: []
}, {
  id: 3,
  title: i18n.global.t('new.guide.part.3.title'),
  href: "#part3",
  isExpanded: false,
  childList: []
}, {
  id: 4,
  title: i18n.global.t('new.guide.part.4.title'),
  href: "#part4",
  isExpanded: false,
  childList: []
}, {
  id: 5,
  title: i18n.global.t('new.guide.part.5.title'),
  href: "#part5",
  isExpanded: false,
  childList: []
}]

const handleClick = (e) => {
  e.preventDefault()
}

</script>
<style lang="less" scoped>
@import "../index";

:deep(.el-icon) {
  font-size: 16px !important;
}
</style>